import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, throwError, timeout } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RequestConfig } from './interfaces/request-config.interface'
import { buildFilterParams } from './utils/filter-param-utils';
import { mergeCleanParams } from './utils/merge-clean-param.utils';
import { getNetworkServiceInstance } from './utils/get-network-service-instance.utils';

@Injectable({
  providedIn: 'root'
})

export class NetworkService {
  static instance: NetworkService;
  private baseUrl = environment.url;
  private schoolId = localStorage.getItem('schoolId');
  constructor(private http: HttpClient) {
    NetworkService.instance = this;
  }
  request<T>(requestConfig: RequestConfig): Observable<T> {
    // console.log('debug network requestConfig');
    const { method, url, body, headers, params, pathParams } = requestConfig;
    // console.log('debug network request got called');

    // Always get the latest schoolId before making a request
    const currentSchoolId = localStorage.getItem('schoolId');
    // Build final URL
    let finalUrl = this.baseUrl + url;
    // console.log('debug network final url', finalUrl);

    if (finalUrl.includes(':schoolId')) {
      // console.log('debug network final url condition ?');
      finalUrl = finalUrl.replace(':schoolId', currentSchoolId);
      // console.log('debug network final url condition ? replaced', finalUrl);
    }

    // Replace dynamic path params from the requestConfig
    if (pathParams) {
      // console.log('debug network pathParams exists condition');
      Object.keys(pathParams).forEach((key) => {
        if (finalUrl.includes(`:${key}`)) {
          // console.log('debug network pathParams final url condition ??');
          finalUrl = finalUrl.replace(`:${key}`, pathParams[key]);
          // console.log('debug network pathParams final url condition ?? replaced', finalUrl);
        }
      });
    }

    // Handle query params
    const queryParams = new HttpParams({ fromObject: params || {} });

    // console.log('debug network queryParams', queryParams);

    // Make request
    return this.http.request<T>(method, finalUrl, {
      body,
      headers,
      params: queryParams,
    });
  }
}

export function GET(
  url: string,
  paramMappings: Record<string, string> = {},
  nestingRules: Record<string, { prefix: string; dynamicKeyFrom: string }> = {},
  removeKeys: Record<string, any> = {},
  filterPerfix: boolean = true,
  timeoutMs?: number  // 👈 Add an optional timeout
) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    descriptor.value = function (...args: any[]) {
      // console.log('descriptor args', args);

      const networkService = getNetworkServiceInstance();
      if (!networkService) return; // Exit if NetworkService is not available

      const queryParams = args[0] || {}; // Base query params
      const filterParams = buildFilterParams(args[1] || {}, paramMappings, nestingRules , filterPerfix); // Filter params
      const pathParams = args[2] || {}; // Base Url params
      // console.log('Filter Params:', filterParams);

      // Merge and clean the final params
      const finalParams = mergeCleanParams(queryParams, filterParams, removeKeys);

      // console.log('final Params:', finalParams);

      let request$ = networkService.request({
        method: 'GET',
        url,
        params: finalParams,
        pathParams: pathParams
      });

      // Apply timeout ONLY if timeoutMs is provided
      if (timeoutMs) {
        request$ = request$.pipe(
          timeout(timeoutMs),
          catchError((err) => {
            console.error(`Request to ${url} timed out after ${timeoutMs / 1000} seconds`);
            return throwError(() => new Error('Request timed out'));
          })
        );
      }

      return request$;
    };
    return descriptor;
  };
}



export function POST(url: string
) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    descriptor.value = function (body: any, path_Params?:any , headers?: any) {
      const networkService = getNetworkServiceInstance();
      if (!networkService) return; // Exit if NetworkService is not available
      const pathParams = path_Params || {}; // Base Url params
      return networkService.request({
        method: 'POST',
        url,
        body,
        pathParams: pathParams,
        headers
      });
    };
    return descriptor;
  };
}

export function PUT(url: string) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    descriptor.value = function (body: any , path_Params?:any) {
      const networkService = getNetworkServiceInstance();
      if (!networkService) return;
      const pathParams = path_Params || {}; // Base Url params
      return networkService.request({
        method: 'PUT',
        url,
        body,
        pathParams: pathParams,
      });
    };
    return descriptor;
  };
}

export function DELETE(url: string) {
  return function (target: any, propertyKey: string, descriptor: PropertyDescriptor) {
    descriptor.value = function (path_Params: any, params?: any,body?:any) {
      const networkService = getNetworkServiceInstance();
      if (!networkService) return;
      const pathParams = path_Params || {}; // Base Url params
      return networkService.request({
        method: 'DELETE',
        url,
        pathParams:pathParams,
        params,
        body
      });
    };
    return descriptor;
  };
}



